import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function MocktailsPage() {

    const heroData = [
        {
          title: "Juices & Mocktails",
          content: "Refresh your senses with our vibrant selection of juices and mocktails. Made from fresh, natural ingredients, our juices are bursting with flavor and nutrients. For a touch of creativity, our mocktails offer delightful blends of fruits, herbs, and sparkling flavors, perfect for any occasion. Sip, savor, and enjoy!",
          image: images.MocktailsHeroImage, 
        },
      ];

    const MocktailsData = [
      {
        name: "Tropical Paradise",
        price: 0,
        image: [
          images.Mocktail1,
        ]
      },
      {
        name: "Berry Bliss",
        price: 0,
        image: [
          images.Mocktail2,
        ]
      },
      {
        name: "Citrus Cooler",
        price: 0,
        image: [
          images.Mocktail3,
        ]
      },
      {
        name: "Watermelon Mojito",
        price: 0,
        image: [
          images.Mocktail4,
        ]
      },
      {
        name: "Ginger Lemongrass Cooler",
        price: 0,
        image: [
          images.Mocktail5,
        ]
      },
      {
        name: "Mango Basil Cooler",
        price: 0,
        image: [
          images.Mocktail6,
        ]
      },
    ]

    const JuicesData = [
      {
        name: "Orange",
        price: 0,
        image: [
          images.Juice1,
        ]
      },
      {
        name: "Pineapple",
        price: 0,
        image: [
          images.Juice2,
        ]
      },
      {
        name: "Watermelon",
        price: 0,
        image: [
          images.Juice3,
        ]
      },
      {
        name: "Carrot",
        price: 0,
        image: [
          images.Juice4,
        ]
      },
      {
        name: "Apple",
        price: 0,
        image: [
          images.Juice5,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Berry Bliss Mocktail",
        image1: [
          images.Mocktail2,
        ],
        content1: "",
        name2: "Orange Juice",
        image2: [
          images.Juice1,
        ],
        content2: ""
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={MocktailsData} title="Asian-Inspired Mocktails" />
            <ProductsSection productData={JuicesData} title="Fresh Juices" />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
